var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" ANNOTATION ")])
}
var staticRenderFns = []

export { render, staticRenderFns }